import { SupplierSettingsMessage } from '../../../types/SupplierSettingsMessage';
import { useToasts } from '../../cdl/Toast/useToasts';
import { updateSupplierSettings } from '../../common/api/clients/company.api';
import { queries } from '../../common/api/queryKeys/queries';
import { translate } from '../../common/helpers/translate.helper';
import { useOptimisticMutation } from '../../common/hooks/useOptimisticMutation';

import { UpdateSupplierSettingsVariables } from './types';

export const useSupplierSettingsOptimisticMutation = (supplierId: string) => {
    const { addErrorToast } = useToasts();

    return useOptimisticMutation<
        SupplierSettingsMessage,
        Error,
        UpdateSupplierSettingsVariables,
        SupplierSettingsMessage
    >({
        mutationFn: updateSupplierSettings,
        optimisticUpdateOptions: {
            queryKey: queries.suppliers.detail(supplierId)._ctx.settings.queryKey,
            optimisticUpdatesFn: ({ prevQueryData, variables }) => {
                return {
                    ...prevQueryData,
                    ...variables.settings,
                };
            },
            invalidateQueryOnSuccess: true,
        },
        onError: () => {
            addErrorToast(translate('company.toasts.informationUpdateError'));
        },
    });
};
